module.exports = __webpack_public_path__ + "img/ribbon.afc8eaf4.png";